<template>
  <div ref="loadMoreRef" class="load-more">
    <TransitionFadeInOut v-if="loading">
      <slot />
    </TransitionFadeInOut>
    <div class="load-early-anchor"></div>
  </div>
</template>
<script lang="ts">
import type { Ref } from 'vue';
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue';
import { TransitionFadeInOut } from '@getaccept/fried-tofu';
import debounce from 'debounce';

export default defineComponent({
  components: {
    TransitionFadeInOut,
  },
  props: {
    loading: {
      type: Boolean,
    },
  },
  setup(_, { emit }) {
    const loadMoreRef: Ref<Element> = ref(null);

    const handleLoadMore = () => {
      emit('load');
    };

    const debounceLoad = debounce(handleLoadMore, 500, true);

    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        debounceLoad();
      }
    });

    onMounted(() => {
      if (loadMoreRef.value) {
        observer.observe(loadMoreRef.value);
      }
    });

    onBeforeUnmount(() => {
      observer.disconnect();
    });

    return { loadMoreRef, handleLoadMore };
  },
});
</script>
<style lang="scss" scoped>
.load-more {
  position: relative;
  width: 100%;
  height: 200px;
  margin-bottom: $spacing-100;

  .load-early-anchor {
    pointer-events: none;
    position: absolute;
    top: -200px;
    height: 200px;
    width: 100%;
  }
}
</style>
